import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapTextArea = React.lazy(function () {
    return import('../../bootstrap-components/components/BTTextArea');
});
var bootStrapTextArea = function (props) {
    return (React.createElement(BootStrapTextArea, { handleChange: props.handleChange, styleName: props.hasError ? 'danger' : props.styleName, label: props.label, ioTheme: props.ioTheme, ioMode: props.ioMode, style: props.style, mandatory: props.mandatory, placeHolder: props.placeHolder, hasError: props.hasError, errorMessage: props.errorMessage, displayType: props.displayType, value: props.value, defaultValue: props.defaultValue, disabled: props.disabled, configId: props.configId, onBlur: props.onBlur, isInlineGridComponent: props.isInlineGridComponent, className: props.className, isFilterComponent: props.isFilterComponent, occuranceNumber: props.occuranceNumber, height: props.height }));
};
export var TextArea = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapTextArea(props);
            break;
        default:
            componentToDisplay = bootStrapTextArea(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
TextArea.defaultProps = {
    styleName: 'primary',
    label: 'TextArea',
    ioTheme: themes[0],
    ioMode: 'light',
    isInlineGridComponent: false
};
//# sourceMappingURL=TextArea.js.map